import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { AnalyticsData } from './analytics.model';
//import Amplify, { Analytics } from 'aws-amplify';
import { SearchResult } from '../model/search-result.model';
import { DocumentAnalyticsData } from './doc-analytics.model';

const SENTRY_TRANSACTION_ID = 'X-Sentry-Transaction-ID';
const ANONYMOUS = 'Anonymous';

declare var dataLayer;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private authService: AuthService) {}

  pushData(analyticsData: AnalyticsData) {
    if (!analyticsData) {
      analyticsData = new AnalyticsData();
    }

    const user = this.authService.currentUser;
    if (user) {
      analyticsData.UserID = user.id;
      analyticsData.CompanyID = user.companyId;
      analyticsData.CompanyUID = user.companyUId;
      analyticsData.UserProfile = user.UserType;
      analyticsData.partialAuth = user.partialAuth;
      analyticsData.traffic_type = user.UserType;
    } else {
      analyticsData.UserProfile = ANONYMOUS;
    }

    if (analyticsData.UserProfile === ANONYMOUS || !user?.connectedAsCustomer) {
      dataLayer.push(analyticsData.toJson());
      console.log(
        'DataLayer pushed to analytics for event : ' + analyticsData.event,
        analyticsData.toJson()
      );
      //this.pushDataToPinpoint(analyticsData);
    }
  }

  // pushWidgetEventData(widgetName: string) {
  //   const analyticsData = new AnalyticsData();
  //   analyticsData.event = 'widgetClicked';
  //   analyticsData.widgetName = widgetName;
  //   const user = this.authService.currentUser;
  //   if (!user.connectedAsCustomer) {
  //     this.pushData(analyticsData);
  //   }
  // }

  pushWidgetEventData(widgetName: string, direction: string = 'vertical') {
    this.pushNavEventLevel_1Data(direction + ' widget', widgetName);
  }

  pushBannerClickEventData(name: string) {
    this.pushNavEventLevel_1Data('banner', name);
  }

  private pushNavEventLevel_1Data(module: string, menu_level_1: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'nav';
    analyticsData.module = module;
    analyticsData.menu_level_1 = menu_level_1;
    this.pushData(analyticsData);
  }

  pushNavClickEvent(
    menu_level_1: string,
    menu_level_2: string,
    menu_level_3: string,
    module: string
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'nav';
    analyticsData.module = module + ' menu';
    analyticsData.menu_level_1 = menu_level_1;
    if (menu_level_2) {
      analyticsData.menu_level_2 = menu_level_2;
    }
    if (menu_level_3) {
      analyticsData.menu_level_3 = menu_level_3;
    }

    this.pushData(analyticsData);
  }

  // pushDataToPinpoint(analyticsData: AnalyticsData) {
  //   // const env=this.configService.getConfig().environment;
  //   // if(true || env === 'production' || env === 'test' ){
  //   //   //console.log(analyticsData);

  //   // }

  //   //greater than 200 characters is not allowed in pinpoint attribute so trim them before sending

  //   analyticsData.token = this.trimTo200Char(analyticsData.token);
  //   analyticsData.DocumentName = this.trimTo200Char(analyticsData.DocumentName);
  //   analyticsData.DocumentUniqueNumber = this.trimTo200Char(
  //     analyticsData.DocumentUniqueNumber
  //   );

  //   Analytics.record({
  //     name: analyticsData.event,
  //     // Attribute values must be strings (to be verified)
  //     attributes: analyticsData.toJson(),
  //     immediate: true,
  //   });
  // }

  // pushDataDirectToPinpoint(event: string, data: any) {
  //   Analytics.record({
  //     name: event,
  //     // Attribute values must be strings (to be verified)
  //     attributes: data,
  //     immediate: true,
  //   });
  // }

  trimTo200Char(text: string): string {
    const maxLength = 199;
    return text && text.length > maxLength
      ? text.substring(0, maxLength - 3) + '...'
      : text;
  }

  pushQueryEnterEvent(query: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'searchQueryEntered';
    analyticsData.query = query;
    this.pushData(analyticsData);
  }

  pushSearchResultData(data: SearchResult, url: string): void {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'searchResult';
    analyticsData.event = 'viewContent';
    analyticsData.uri = url;
    analyticsData.Service = data.service;
    analyticsData.Region = data.region;
    analyticsData.DocumentType = data.docType;
    analyticsData.topic = data.pillar;
    analyticsData.country = data.country;
    analyticsData.query = data.replacedQuery ? data.replacedQuery : data.query;
    analyticsData.resultCount = data.groupedHitCount;
    analyticsData.currentPage = data.currentPage;
    analyticsData.fromTo =
      data.fromPublicationDate + ':' + data.untilPublicationDate;
    analyticsData.searchSort = data.searchSortCriteria;
    this.pushData(analyticsData);
  }

  pushOnSearchPageScroll(currentPage: number) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'searchScrolled';
    analyticsData.currentPage = currentPage;
    this.pushData(analyticsData);
  }

  pushOnSearchCriteriaChange(sortCriteria: any) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'searchSortClicked';
    analyticsData.searchSort = sortCriteria;
    this.pushData(analyticsData);
  }

  pushSearchFacetClick(
    service: string,
    pillar: string,
    region: string,
    docType: string
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'searchFacetClicked';
    analyticsData.Service = service;
    analyticsData.topic = pillar;
    analyticsData.Region = region;
    analyticsData.DocumentType = docType;
    this.pushData(analyticsData);
  }

  pushSearchPeriodClick(from: string, to: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'periodFacetClicked';
    analyticsData.fromTo = from + ':' + to;
    this.pushData(analyticsData);
  }

  pushErrorEvent(request: any, error: any, responseTime: any, uri: string) {
    const data = new AnalyticsData();
    data.event = 'error';
    data.apiUrl = request.url;
    data.uri = uri;
    data.errorStatus = error.status;
    data.timestamp = new Date().toLocaleString();
    data.token = request.headers.get('authorization');
    data.responseTime = responseTime;
    if (request.headers.has(SENTRY_TRANSACTION_ID)) {
      data.transactionId = request.headers.get(SENTRY_TRANSACTION_ID);
    }
    if (error.status === 401) {
      data.nonAuthorisedAccess = true;
    }
    this.pushData(data);
    return data;
  }

  pushHomePageViewData(url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'homePage';
    analyticsData.event = 'viewContent';
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushServicePageData(url: string, service: string, nonRightAccess: boolean) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'servicePage';
    analyticsData.event = 'viewContent';
    analyticsData.uri = url;
    analyticsData.Service = service;
    analyticsData.nonAuthorisedAccess = nonRightAccess;
    analyticsData.navigationListType = 'service';
    this.pushData(analyticsData);
  }

  pushRegionPageViewData(
    url: string,
    service: string,
    region: string,
    nonRightAccess: boolean
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'regionPage';
    analyticsData.event = 'viewContent';
    analyticsData.uri = url;
    analyticsData.Service = service;
    analyticsData.Region = region;
    analyticsData.nonAuthorisedAccess = nonRightAccess;
    analyticsData.navigationListType = 'region';
    this.pushData(analyticsData);
  }

  pushPillarPageViewData(
    url: string,
    service: string,
    pillar: string,
    nonRightAccess: boolean
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'pillarPage';
    analyticsData.event = 'viewContent';
    analyticsData.uri = url;
    analyticsData.Service = service;
    analyticsData.topic = pillar;
    analyticsData.nonAuthorisedAccess = nonRightAccess;
    analyticsData.navigationListType = 'pillar';
    this.pushData(analyticsData);
  }

  pushDocTypePageViewData(
    url: string,
    service: string,
    docType: string,
    nonRightAccess: boolean
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'documentPage';
    analyticsData.event = 'viewContent';
    analyticsData.uri = url;
    analyticsData.Service = service;
    analyticsData.DocumentType = docType;
    analyticsData.nonAuthorisedAccess = nonRightAccess;
    analyticsData.navigationListType = 'docType';
    this.pushData(analyticsData);
  }

  pushOnDomainPageTabClick(tabName: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'domainPageTabClicked';
    analyticsData.tabName = tabName;
    this.pushData(analyticsData);
  }

  pushUpgradeSubscriptionEvent(
    event: string,
    service: string,
    uniqueNumber: string
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.Service = service;
    analyticsData.DocumentUniqueNumber = uniqueNumber;
    analyticsData.event = event;
    this.pushData(analyticsData);
  }

  pushAudioAnalyticsData(event, progressValue: number, docData: any) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'audio';
    analyticsData.audioTitle = decodeURIComponent(
      event.target.currentSrc.split('/')[
        event.target.currentSrc.split('/').length - 1
      ]
    );
    switch (event.type) {
      case 'play':
        analyticsData.audioPlayerAction = 'play';
        break;
      case 'pause':
        analyticsData.audioPlayerAction = 'pause';
        break;
      case 'ended':
        analyticsData.audioPlayerAction = 'ended';
        break;
      case 'timeupdate':
        analyticsData.audioPlayerAction = 'timeupdate';
        break;
      default:
        break;
    }
    analyticsData.audioValue = progressValue;
    analyticsData.DocumentUniqueNumber = docData.uniqueNumber;
    analyticsData.DocumentType = docData.documentType;
    this.pushData(analyticsData);
  }

  pushTableViewData(docData: any, url: string, viewName: string) {
    const analyticsData = new DocumentAnalyticsData(docData, url);
    analyticsData.PageType = 'tableViewer';
    analyticsData.event = 'viewTable';
    analyticsData.DocumentName = viewName;
    analyticsData.DocumentType = 'TABLE_VIEW ';
    this.pushData(analyticsData);
  }

  pushDocumentViewData(docData: any, url: string) {
    const analyticsData = new DocumentAnalyticsData(docData, url);
    this.pushData(analyticsData);
  }

  pushDocActionIconClickData(event: string, url: string, docData: any) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = event;
    analyticsData.DocumentName = docData.title;
    analyticsData.DocumentUniqueNumber = docData.uniqueNumber;
    analyticsData.DocumentInstanceId = docData.documentInstanceid;
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushLoginEvents(event: string, uniqueNumber: string, url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = event;
    analyticsData.DocumentUniqueNumber = uniqueNumber;
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushSelfRegisterEvent_StepEmail() {
    this.pushSelfRegisterEvent_Step('Step_01', 'email');
  }

  pushSelfRegisterEvent_StepPersonalDetails() {
    this.pushSelfRegisterEvent_Step('Step_02', 'personalDetails');
  }

  private pushSelfRegisterEvent_Step(step: string, stepName: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.WebApp = 'public';
    analyticsData.event = 'selfRegister';
    analyticsData.PageType = 'selfRegister';
    analyticsData.step = step;
    analyticsData.stepName = stepName;
    this.pushData(analyticsData);
  }

  pushSelfRegisterEvent_StepPassword() {
    this.pushSelfRegisterEvent_Step('Step_03', 'password');
  }
  pushSelfRegisterEvent_StepValidation() {
    this.pushSelfRegisterEvent_Step('Step_04', 'validation');
  }

  pushSelfRegisterEvent_StepAccountActivationSuccess() {
    this.pushSelfRegisterEvent_Step('Step_05', 'accountActivation');
  }

  pushSelfRegisterAccountActivationFailureEvent(url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.WebApp = 'public';
    analyticsData.event = 'selfRegister_AccountActivationFailure';
    analyticsData.uri = url;
    analyticsData.PageType = 'selfRegister';
    this.pushData(analyticsData);
  }

  pushResetPasswordEvents(event: string, url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = event;
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushGTMapClickEventData(country: string, url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'mapClick';
    analyticsData.Service = 'global_trends';
    analyticsData.Region = country;
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushGTNewsClickEventData(
    reportTitle: string,
    newsTitle: string,
    url: string
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = 'newsClick';
    analyticsData.Service = 'global_trends';
    analyticsData.DocumentName = newsTitle;
    //analyticsData.title = newsTitle;
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushGTHomePageViewData(url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'home';
    analyticsData.uri = url;
    this.pushData(analyticsData);
  }

  pushGTArchivesViewData(url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'reportArchives';
    analyticsData.uri = url;
    analyticsData.event = 'viewList';
    analyticsData.Service = 'global_trends';
    this.pushData(analyticsData);
  }

  pushGTReportViewData(
    data: any,
    url: string,
    nonAuthorisedAccess: boolean = false
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'trendReport';
    analyticsData.uri = url;
    analyticsData.DocumentName = data.title;
    analyticsData.Service = 'global_trends';
    analyticsData.nonAuthorisedAccess = nonAuthorisedAccess;
    analyticsData.Author =
      data.publisher.firstName + ' ' + data.publisher.lastName;
    this.pushData(analyticsData);
  }

  pushViewTrainingDetailEvent(id: number, title: string, url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'training';
    analyticsData.uri = url;
    analyticsData.event = 'viewContent';
    analyticsData.trainingId = id;
    analyticsData.DocumentName = title;
    this.pushData(analyticsData);
  }

  pushViewTrainingCatalogEvent(url: string) {
    const analyticsData = new AnalyticsData();
    analyticsData.PageType = 'training';
    analyticsData.uri = url;
    analyticsData.event = 'viewContent';
    analyticsData.DocumentName = 'home';
    this.pushData(analyticsData);
  }

  pushBuyTrainingClickEvent(id: number, title: string, url: string) {
    this.pushTrainingClickEvent('buyTrainingClick', id, title, url);
  }

  pushRegisteredTrainingClickEvent(id: number, title: string, url: string) {
    this.pushTrainingClickEvent('registeredTrainingClick', id, title, url);
  }

  pushCompletedTrainingClickEvent(id: number, title: string, url: string) {
    this.pushTrainingClickEvent('completedTrainingClick', id, title, url);
  }

  private pushTrainingClickEvent(
    event: string,
    id: number,
    title: string,
    url: string
  ) {
    const analyticsData = new AnalyticsData();
    analyticsData.event = event;
    analyticsData.trainingId = id;
    analyticsData.DocumentName = title;
    analyticsData.uri = url;
    analyticsData.PageType = 'training';
    this.pushData(analyticsData);
  }
}
